import useSingleTemplate from "~/hooks/templates/getSingleTemplate";
import useData, { type UseDataReturn } from "~/hooks/useData";
import type { Form } from "~/types/collections";

const useGetSingleForm = ({
  templateId,
  serialLoading,
}: {
  templateId?: string;
  serialLoading: boolean;
}): UseDataReturn<Form> => {
  const { data, isLoading: templateLoading } = useSingleTemplate({
    id: templateId,
  });

  // Get the related form.

  return useData<Form>({
    serialLoading: serialLoading || templateLoading,
    collection: "forms",
    id:
      typeof data?.form === "object" && data?.form !== null
        ? (data.form as Form).id
        : undefined,
  });
};

export default useGetSingleForm;
